/**
 * Trust strip — admin-editable cards (up to 6) shown where the old testimonials
 * were. A card with type "live_count" renders a real, never-padded member count
 * from /api/public/stats.
 */
import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/App";

const liveCountLabel = (stats) => {
  const x = stats?.total_members ?? 0;
  return `${x} dentists preparing for the ADC exam`;
};

const Card = ({ card, stats }) => {
  const isLive = card.type === "live_count";
  const title = isLive ? liveCountLabel(stats) : card.title;
  const inner = (
    <div className="glass rounded-2xl p-6 border border-border h-full flex flex-col justify-center text-center" data-testid="trust-card">
      <p className="text-base font-semibold">{title}</p>
      {card.sub_line && <p className="text-sm text-muted-foreground mt-1">{card.sub_line}</p>}
    </div>
  );
  if (card.link_url) {
    return <a href={card.link_url} className="block hover:opacity-90 transition-opacity">{inner}</a>;
  }
  return inner;
};

const TrustStrip = ({ data }) => {
  const [stats, setStats] = useState(null);
  const cards = (data?.cards || []).slice(0, 6);
  const hasLive = cards.some((c) => c.type === "live_count");

  useEffect(() => {
    if (hasLive) axios.get(`${API}/public/stats`).then((r) => setStats(r.data)).catch(() => {});
  }, [hasLive]);

  if (data?.show_section === false || cards.length === 0) return null;

  return (
    <section className="py-16 px-6 border-t border-border" data-testid="trust-strip">
      <div className="max-w-5xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5">
        {cards.map((c, i) => <Card key={i} card={c} stats={stats} />)}
      </div>
    </section>
  );
};

export default TrustStrip;
